export class ModalHelper {

	public static scrollToErrorDisplay() {
		var dialog = document.querySelectorAll('.cascade')[0];
		if(dialog) {
			dialog.scrollTop = 0;
			window.setTimeout(() => {
				let errorClose = dialog.querySelectorAll('.ms-MessageBar-content .ms-Button')[0];
				if(errorClose) {
					(<HTMLElement>errorClose).focus();
				}
			}, 100);
		}
	}

	public static scrollToBottom()
	{	
        let dialogMain:any = document.querySelector(".ms-Dialog-main");
        if(dialogMain)
        setTimeout(() => {
            var scrollHeight = dialogMain.scrollHeight;
            ModalHelper.scrollTo(scrollHeight);
        },200); 
	}
	
	public static scrollTo(scrollPoint: number, applyDelay?: boolean) {
		var dialog = document.querySelectorAll('.ms-Dialog-main')[0];
		if(dialog) {
			dialog.scrollTop = scrollPoint;
		}
	}

}


// WEBPACK FOOTER //
// ./source/ts/helpers/modal.ts